import { render, staticRenderFns } from "./PostingLog.vue?vue&type=template&id=24bb0e61"
import script from "./PostingLog.vue?vue&type=script&lang=js"
export * from "./PostingLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports